import {
  AssessmentScore,
  AssessmentTreatmentSteps,
  AssessmentTreatment,
  Testimonials
} from '@cerebral-inc/wode-screener-questions';
import { BIPOLAR_ASSESSMENT_RESULT } from 'constants/localStorageKey';
import { getStaticFilePath } from 'components/shared/utils';
import { IQuestion } from 'components/assessment-flow/types';
import { AssessmentWrapper } from 'components/shared/styled';
import {
  assessmentData,
  mdqInterpretation,
  negativeDescription,
  positiveDescription
} from './utils';
import { IAssessmentData } from '../DepressionAssessmentResult/types';

const BipolarAssessmentResult = () => {
  const { assessmentScore, assessmentTreatment, steps } =
    assessmentData as IAssessmentData;
  const data = JSON.parse(
    localStorage.getItem(BIPOLAR_ASSESSMENT_RESULT) || '[]'
  ) as IQuestion[];
  const severity = mdqInterpretation(data);

  const handleContinue = async () => {
    window.open(`${process.env.REACT_APP_CLIENT_APP_URL}`, '_self');
  };

  return (
    <AssessmentWrapper>
      <AssessmentScore
        score={0}
        maxScore={15}
        title={assessmentScore.title}
        description={
          severity === 'Positive' ? positiveDescription : negativeDescription
        }
        serviceLine={assessmentScore.serviceLine}
        onSubmit={handleContinue}
        buttonText={assessmentScore.buttonText}
        severity={severity}
      />
      <AssessmentTreatment
        title={assessmentTreatment.title}
        description={assessmentTreatment.description}
        onSubmit={handleContinue}
        ctaText={assessmentTreatment.ctaText}
        subscript={assessmentTreatment.subscript}
        treatmentOptions={assessmentTreatment.treatmentOptions}
        cerebralRx={assessmentTreatment.cerebralRx}
        image={getStaticFilePath(assessmentTreatment.image.desktop)}
      />
      <AssessmentTreatmentSteps onSubmit={handleContinue} steps={steps} />
      <Testimonials />
    </AssessmentWrapper>
  );
};

export default BipolarAssessmentResult;
